import React, { useMemo } from 'react';
import DynamicSwipeBlock from '../DynamicSwipeBlock/DynamicSwipeBlock';
import { useSelectedCampaign, normalizeCampaignAssets } from 'features/campaigns';

interface CampaignCollapsibleControlsProps {
  hasMany: boolean;
  arrow?: string;
  isCollapsed: boolean;
  onArrowClick: () => void;
  swipeBlockClassName?: string;
  arrowClassName?: string;
  arrowRotatedClassName?: string;
}

const CampaignCollapsibleControls: React.FC<CampaignCollapsibleControlsProps> = ({
  arrow,
  isCollapsed,
  onArrowClick,
  swipeBlockClassName,
  arrowClassName,
  arrowRotatedClassName,
}) => {
const campaign = useSelectedCampaign();

  const normalizedAssets = useMemo(
    () => campaign && campaign.type ? normalizeCampaignAssets(campaign.resources, campaign.type) : null,
    [campaign]
  );

  return (
    <>
      <DynamicSwipeBlock
        borderColor={normalizedAssets?.colors.border}
        fillColor={normalizedAssets?.colors.fill}
        className={swipeBlockClassName}
        onClick={onArrowClick}
      />

      {arrow && (
        <img
          src={arrow}
          alt="arrow"
          className={`${arrowClassName} ${isCollapsed ? arrowRotatedClassName : ''}`}
        />
      )}
    </>
  );
};

export default CampaignCollapsibleControls;
